import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Join } from './Join'
import { Instruction } from './Instruction'
import { Start } from './Start'
import { GameStart } from './GameStart'
import App from './App'
import Answer from './Answer'
import Ranking from './Ranking'
import ViewQuizResult from './ViewQuizResult'
import { ConnectionLost } from './ConnectionLost'
import SurveyJoin from './survey/SurveyJoin'
import SurveyStart from './survey/SurveyStart'
import ThankYou from './survey/ThankYou'
const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path='/'  element={<App />} />
        <Route exact path=':id'  element={<Join />} />
        <Route exact path='instruction'  element={<Instruction />} />
        <Route exact path='start' element={<Start />} />
        <Route exact path='game-start'  element={<GameStart />} />
        <Route exact path='answer'  element={<Answer />} />
        <Route exact path='ranking'  element={<Ranking />} />
        <Route exact  path='quiz-result/:quiz_id/:pin_id' element={<ViewQuizResult />} />
        <Route exact  path='survey/:key' element={<SurveyJoin />} />
        <Route exact path='survey/start/:key' element={<SurveyStart />} />
        <Route exact path='survey/thank-you' element={<ThankYou />} />


        <Route path='*'  element={<Navigate to="/"/>} />

      </Routes>
    </BrowserRouter>
  )
}

export default Router
